import { useEffect, useRef, useState } from "react";
import Carousel from "react-multi-carousel";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "react-multi-carousel/lib/styles.css";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import {
  Avatar,
  Box,
  Grid,
  Stack,
  Container,
  Typography,
  useMediaQuery,
  useTheme,
  Button,
} from "@mui/material";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import { useAsync } from "react-use";
import ImagesCover from "Assets/free-trial/ALBUMCOVERS.png";
import Ellipse from "Assets/free-trial/Ellipse.png";
import EllipseBottom from "Assets/free-trial/EllipseBottom.png";
import GrainBg from "Assets/free-trial/Grain-bg.png";
import CardsBg from "Assets/free-trial/cards_bg.png";
import TestimonialsBgMobile from "Assets/free-trial/testimonials_bg_mobile.png";
import TestimonialsBg from "Assets/free-trial/testimonials_bg.png";
import Logo from "Pages/Components/Logo";
import ContentfulClient from "Utils/ContentfulClient";
import {
  PremiumQualityIcon,
  PremiumSilenceIcon,
  PremiumSkipIcon,
} from "./Components/Icons";
import Title from "Pages/Components/Title";
import { FreeTrialDocDto } from "../../types/Donate";
import UnlimitedAccessIcon from "./Components/Icons/UnlimitedAccessIcon";
import styles from "./Components/FreeTrial/FreeTrial.module.css";
import ChrisBotti from "Assets/free-trial/photos/chris-botti.png";
import BradMehldau from "Assets/free-trial/photos/Brad-Mehldau.png";
import ChetBaker from "Assets/free-trial/photos/Chet-Baker-Mobile.png";
import DianaKrall from "Assets/free-trial/photos/Diana-Krall.png";
import LouisArmstrong from "Assets/free-trial/photos/Louis-Armstrong-Pyramids-Mobile.png";
import MilesDavis from "Assets/free-trial/photos/Miles.png";
import SonnyRollins from "Assets/free-trial/photos/Sonny-Rollins.png";
import WyntonMarsalis from "Assets/free-trial/photos/Wynton-Marsalis-Mobile.png";
import BrandeeYounger from "Assets/free-trial/photos/Brandee-Younger.png";
import DillyGillespie from "Assets/free-trial/photos/Dizzy-Gillespie.png";
import DukeEllington from "Assets/free-trial/photos/Duke-Ellington.png";
import EllaBest from "Assets/free-trial/photos/Ella-Best.png";
import RayCharles from "Assets/free-trial/photos/Ray-Charles.png";
import HerbieHancock from "Assets/free-trial/photos/Herbie-Hancock.png";
import { Link, useHistory } from "react-router-dom";
import Footer from "./Components/Footer/Footer";
import Player from "./Components/Player/Player";
import { getPKCEState } from "react-auth0-spa";
import { useCookies } from "react-cookie";
import { Auth0Lock } from "auth0-lock";
import { IoMdPhonePortrait } from "react-icons/io";
import { FaTabletAlt } from "react-icons/fa";
import { HiMiniComputerDesktop } from "react-icons/hi2";
import { BsFillSpeakerFill } from "react-icons/bs";
import { SiSonos } from "react-icons/si";
import { SiAmazonalexa } from "react-icons/si";
import { SiTunein } from "react-icons/si";
import { SiAndroidauto } from "react-icons/si";
import { FaApple } from "react-icons/fa";
import { FaChromecast } from "react-icons/fa";
import { FiAirplay } from "react-icons/fi";
import Heos from "Assets/heos.png";
import { useAppContext } from "Context";
import BenefitsPopup from "Utils/Components/FreeTrial/BenefitsPopup";

const BACKUP_COUPON = "fttest2";
const BACKUP_VERSION = "a";

const legends = [
  { name: "Louis Armstrong", image: LouisArmstrong },
  { name: "Chris Botti", image: ChrisBotti },
  { name: "Ella Fitzgerald", image: EllaBest },
  { name: "Dizzy Gillespie", image: DillyGillespie },
  { name: "Chet Baker", image: ChetBaker },
  { name: "Ray Charles", image: RayCharles },
  { name: "Duke Ellington", image: DukeEllington },
  { name: "Diana Krall", image: DianaKrall },
  { name: "Miles Davis", image: MilesDavis },
  { name: "Wynton Marsalis", image: WyntonMarsalis },
  { name: "Brad Mehldau", image: BradMehldau },
  { name: "Herbie Hancock", image: HerbieHancock },
  { name: "Sonny Rollins", image: SonnyRollins },
  { name: "Brandee Younger", image: BrandeeYounger },
  { name: "Louis Armstrong", image: LouisArmstrong },
  { name: "Chris Botti", image: ChrisBotti },
  { name: "Ella Fitzgerald", image: EllaBest },
  { name: "Dizzy Gillespie", image: DillyGillespie },
  { name: "Chet Baker", image: ChetBaker },
  { name: "Ray Charles", image: RayCharles },
  { name: "Duke Ellington", image: DukeEllington },
  { name: "Diana Krall", image: DianaKrall },
  { name: "Miles Davis", image: MilesDavis },
  { name: "Wynton Marsalis", image: WyntonMarsalis },
  { name: "Brad Mehldau", image: BradMehldau },
  { name: "Herbie Hancock", image: HerbieHancock },
  { name: "Sonny Rollins", image: SonnyRollins },
  { name: "Brandee Younger", image: BrandeeYounger },
  { name: "Louis Armstrong", image: LouisArmstrong },
  { name: "Chris Botti", image: ChrisBotti },
  { name: "Ella Fitzgerald", image: EllaBest },
  { name: "Dizzy Gillespie", image: DillyGillespie },
  { name: "Chet Baker", image: ChetBaker },
  { name: "Ray Charles", image: RayCharles },
  { name: "Duke Ellington", image: DukeEllington },
  { name: "Diana Krall", image: DianaKrall },
  { name: "Miles Davis", image: MilesDavis },
  { name: "Wynton Marsalis", image: WyntonMarsalis },
  { name: "Brad Mehldau", image: BradMehldau },
  { name: "Herbie Hancock", image: HerbieHancock },
  { name: "Sonny Rollins", image: SonnyRollins },
  { name: "Brandee Younger", image: BrandeeYounger },
  { name: "Louis Armstrong", image: LouisArmstrong },
  { name: "Chris Botti", image: ChrisBotti },
  { name: "Ella Fitzgerald", image: EllaBest },
  { name: "Dizzy Gillespie", image: DillyGillespie },
  { name: "Chet Baker", image: ChetBaker },
  { name: "Ray Charles", image: RayCharles },
  { name: "Duke Ellington", image: DukeEllington },
  { name: "Diana Krall", image: DianaKrall },
  { name: "Miles Davis", image: MilesDavis },
  { name: "Wynton Marsalis", image: WyntonMarsalis },
  { name: "Brad Mehldau", image: BradMehldau },
  { name: "Herbie Hancock", image: HerbieHancock },
  { name: "Sonny Rollins", image: SonnyRollins },
  { name: "Brandee Younger", image: BrandeeYounger },
  { name: "Louis Armstrong", image: LouisArmstrong },
  { name: "Chris Botti", image: ChrisBotti },
  { name: "Ella Fitzgerald", image: EllaBest },
  { name: "Dizzy Gillespie", image: DillyGillespie },
  { name: "Chet Baker", image: ChetBaker },
  { name: "Ray Charles", image: RayCharles },
  { name: "Duke Ellington", image: DukeEllington },
  { name: "Diana Krall", image: DianaKrall },
  { name: "Miles Davis", image: MilesDavis },
  { name: "Wynton Marsalis", image: WyntonMarsalis },
  { name: "Brad Mehldau", image: BradMehldau },
  { name: "Herbie Hancock", image: HerbieHancock },
  { name: "Sonny Rollins", image: SonnyRollins },
  { name: "Brandee Younger", image: BrandeeYounger },
  { name: "Louis Armstrong", image: LouisArmstrong },
  { name: "Chris Botti", image: ChrisBotti },
  { name: "Ella Fitzgerald", image: EllaBest },
  { name: "Dizzy Gillespie", image: DillyGillespie },
  { name: "Chet Baker", image: ChetBaker },
  { name: "Ray Charles", image: RayCharles },
  { name: "Duke Ellington", image: DukeEllington },
  { name: "Diana Krall", image: DianaKrall },
  { name: "Miles Davis", image: MilesDavis },
  { name: "Wynton Marsalis", image: WyntonMarsalis },
  { name: "Brad Mehldau", image: BradMehldau },
  { name: "Herbie Hancock", image: HerbieHancock },
  { name: "Sonny Rollins", image: SonnyRollins },
  { name: "Brandee Younger", image: BrandeeYounger },
];

const testimonials = [
  {
    name: "Doug",
    comment:
      "My wife and I love The Jazz Groove! We listen to it everytime we are at home; the playlists are absolutely first-rate, don't change a thing!",
  },
  {
    name: "Jane",
    comment:
      "The Jazz Groove is the best! I love laid-back Jazz but had never found a station that consistently played it... For something that provides me with so much enjoyment, I happily contribute.",
  },
  {
    name: "Bill & Joan",
    comment:
      "We just made our annual contribution to The Jazz Groove. The calming effect The Jazz Groove has on our pets is just amazing",
  },
  {
    name: "Bill",
    comment:
      "It is so relaxing and puts me in such a great headspace—I just enjoy listening on a daily basis",
  },
  {
    name: "Artie",
    comment:
      "I keep contributing to The Jazz Groove because the station just resonates with me. Your music helps me balance, mentally—you're just doing everything right. Keep up the good work",
  },
  {
    name: "Christopher",
    comment:
      "There’s no other station with music so carefully curated. When I come home in the evening, all I need to do is put it on, sit back and relax",
  },
  {
    name: "Daryl",
    comment:
      "With all the jazz stations out there, The Jazz Groove stands out with the selection of music and tone that we were looking for",
  },
  {
    name: "Bill",
    comment:
      "As a devoted and grateful listener, it’s easy to speak in superlatives when discussing The Jazz Groove. It's my daily companion, the music station I go to first, last and always",
  },
];

const responsive = {
  superLargeDesktop: {
    breakpoint: { max: 4000, min: 3000 },
    items: 7,
  },
  desktop: {
    breakpoint: { max: 3000, min: 1500 },
    items: 6,
  },
  smalldesktop: {
    breakpoint: { max: 1500, min: 1024 },
    items: 5,
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 3,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
  },
};

function Device(props: {
  icon?: React.ElementType;
  image?: string;
  title: string;
  body: string | JSX.Element;
  height?: string;
  size?: number;
}) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <Grid
      item
      xs={6}
      md={3}
      sx={{ px: 1, pt: isMobile ? 2 : 0, mt: isMobile ? 3 : 5 }}
    >
      {props?.image && (
        <img
          src={props.image}
          height={props?.height ? props.height : "50px"}
          alt="icon"
          style={{ marginTop: isMobile ? 3 : 25 }}
        />
      )}

      {props?.icon && (
        <props.icon size={props?.size ? props.size : 70} color="#ffffff" />
      )}
      {props?.title && (
        <Box style={{ marginTop: 4 }}>
          <Typography
            sx={{
              fontFamily: "futura-pt",
              fontWeight: 450,
              fontSize: "1.5em",
            }}
          >
            {props.title}
          </Typography>
        </Box>
      )}
      {props?.body && (
        <Typography
          sx={{
            fontFamily: "futura-pt",
            fontWeight: 400,
            fontSize: "1.5em",
            color: "#b0b0b0",
          }}
        >
          {props.body}
        </Typography>
      )}
    </Grid>
  );
}

function Perk(props: {
  icon: React.ElementType;
  title: string;
  body: string | JSX.Element;
}) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const iconSize = isMobile ? 80 : 208;
  return (
    <Stack
      direction={isMobile ? "row" : "column"}
      spacing={2}
      sx={{
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Box sx={{ width: iconSize }}>
        <props.icon
          style={{
            width: iconSize,
            height: iconSize,
            flexShrink: 0,
          }}
        />
      </Box>
      <Box
        sx={{
          textAlign: isMobile ? "left" : "center",
          flex: "auto",
        }}
      >
        <Typography variant="h5" component="p" sx={{ pb: isMobile ? 0 : 1 }}>
          {props.title}
        </Typography>
        <Typography variant="body2" style={{ fontSize: "18px" }}>
          {props.body}
        </Typography>
      </Box>
    </Stack>
  );
}

const stripe = loadStripe(process.env.REACT_APP_STRIPE_API_KEY as string);

const FreeTrial = (props) => {
  const theme = useTheme();
  const { paused, songRawData } = useAppContext();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const isSmallMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTinyMobile = useMediaQuery("(max-width: 400px)");
  // console.log("🚀 ~ FreeTrial ~ isMobile:", isMobile);
  const isSmallDesktop = useMediaQuery(theme.breakpoints.down("lg"));
  const isMediumDesktop = useMediaQuery("(max-width: 1370px)");
  // console.log("🚀 ~ FreeTrial ~ isMediumDesktop:", isMediumDesktop);
  // console.log("🚀 ~ FreeTrial ~ isSmallDesktop:", isSmallDesktop);
  const [contentfulEntry, setContentfulEntry] = useState<null | string>(null);
  const [coupon, setCoupon] = useState<null | string>(null);
  const [currentSongRawData, setCurrentSongRawData] = useState<null | any>(
    null
  );
  const [showBenefitsPopup, setShowBenefitsPopup] = useState<boolean>(false);
  const [showPopupCloseOption, setShowPopupCloseOption] =
    useState<boolean>(false);
  const [pageVersion, setPageVersion] = useState<null | string>(null);
  const formRef = useRef<null | HTMLDivElement>(null);
  let sliderRef = useRef<Slider | null>(null);

  const [cookies, setCookie] = useCookies([
    "seenFinalPopup",
    "freeTrialCoupon",
    "freeTrialVersion",
  ]);

  const seenFinalPopupCookie = cookies.seenFinalPopup;

  const [lock, setLock] = useState<any>(null);

  // "Try It Free" always starts a free trial on the new donate page: this page's
  // ?c= is passed on as ?coupon=, and a link without one falls back to
  // "freetrial" so the visitor still lands on the trial rather than the ordinary
  // donate form. A code Chargebee doesn't know is simply not applied.
  const history = useHistory();
  const goToTrialCheckout = () => {
    const c =
      new URLSearchParams(window.location.search).get("c") || "freetrial";
    history.push(`/checkout/v3?coupon=${encodeURIComponent(c)}`);
  };

  const legendsItems: [JSX.Element?] = [];
  legends.forEach((legend) => {
    legendsItems.push(
      <div>
        <Box
          sx={{
            width: isMobile ? "180px" : "280px",
            height: isMobile ? "180px" : "280px",
            borderRadius: "18px",
            background: `url(${legend.image})`,
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
            textAlign: "center",
            zIndex: 2,
          }}
        >
          <Box
            sx={{
              position: "absolute",
              bottom: "20px",
              width: "100%",
              textAlign: "center",
              zIndex: 5,
            }}
          >
            <Typography variant={"body1"}>{legend.name}</Typography>
          </Box>
          <Box
            sx={{
              position: "absolute",
              bottom: "0px",
              width: isMobile ? "180px" : "280px",
              height: isMobile ? "70px" : "140px",
              borderRadius: "18px",
              backgroundImage: `linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, #000000 100%)`,
              zIndex: 3,
            }}
          ></Box>
        </Box>
      </div>
    );
  });

  const testimonialsItems: [JSX.Element?] = [];
  testimonials.forEach((legend) => {
    testimonialsItems.push(
      <Grid
        container
        xs={12}
        sx={{
          minHeight: isTinyMobile
            ? "250px"
            : isMediumDesktop
            ? "327px"
            : "160px",
          borderRadius: "18px",
          background: `url(${
            isMediumDesktop ? TestimonialsBgMobile : TestimonialsBg
          })`,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          zIndex: 5,
        }}
      >
        <Grid
          item
          sx={{
            zIndex: 5,
          }}
          xs={12}
        >
          <Box
            sx={{
              display: "block",
              textAlign: "center",
              padding: isTinyMobile
                ? "80px 15px 10px "
                : isMediumDesktop
                ? "120px 20px 10px"
                : "50px 50px 10px",
            }}
          >
            <Typography variant={"body1"}>{legend.comment}</Typography>
            <Typography variant={"body1"}>
              <b>{legend.name}</b>
            </Typography>
          </Box>
        </Grid>
      </Grid>
    );
  });

  const { value: freeTrialDoc } = useAsync(async () => {
    if (contentfulEntry) {
      const entry = await ContentfulClient.getEntry<FreeTrialDocDto>(
        contentfulEntry
      );

      let options = {
        renderNode: {
          "embedded-asset-block": (node) => (
            <img
              className="img-fluid"
              src={node.data.target.fields.file.url}
              alt="img"
            />
          ),
        },
      };
      const ret = {
        welcomeContent: documentToReactComponents(
          entry.fields.freeTrialWelcomeText,
          options
        ),
        thankYouHeader: entry.fields.thankYouPageContentHeader,
        thankYouContent: documentToReactComponents(
          entry.fields.thankYouPageContent
        ),
        inactiveFreeTrialText: documentToReactComponents(
          entry.fields.inactiveFreeTrialText
        ),
        active: entry.fields.freeTrialActive,
      };
      return ret;
    }
  }, [contentfulEntry]);

  useEffect(() => {
    const queryString = window.location.search;
    const params = new URLSearchParams(queryString);
    const couponParam = params.get("c") || BACKUP_COUPON;
    const pageVersion = params.get("v") || BACKUP_VERSION;

    setCookie("freeTrialCoupon", couponParam, { maxAge: 60 * 60 * 24 });
    setCookie("freeTrialVersion", pageVersion, { maxAge: 60 * 60 * 24 });

    if (
      !paused &&
      ((!currentSongRawData?.id && songRawData?.id) ||
        (currentSongRawData?.id && currentSongRawData.id !== songRawData?.id))
    ) {
      // console.log("Song has changed", songRawData);
      setCurrentSongRawData(songRawData);
    }

    if (!paused && songRawData?.tags["jg-dp"]) {
      // console.log("Delayed pop-up tag detected");
      setTimeout(() => {
        setShowPopupCloseOption(true);
        setShowBenefitsPopup(true);

        // console.log("Delayed for 15 second.");
      }, 15000);
    }

    if (!paused && songRawData?.tags["jg-fp"]) {
      setShowPopupCloseOption(false);
      setShowBenefitsPopup(true);

      setCookie("seenFinalPopup", "true", { maxAge: 60 * 60 * 24 });
    }

    if (seenFinalPopupCookie) {
      setShowPopupCloseOption(false);
      setShowBenefitsPopup(true);
    }

    // console.log(songRawData);
  }, [
    songRawData,
    currentSongRawData,
    paused,
    seenFinalPopupCookie,
    setCookie,
  ]);

  useEffect(() => {
    const queryString = window.location.search;
    const params = new URLSearchParams(queryString);
    const queryContentfulEntry = params.get("entity");
    const couponParam = params.get("c") || BACKUP_COUPON;
    const pageVersion = params.get("v") || BACKUP_VERSION;

    async function initializeAuth0() {
      var clientId = process.env.REACT_APP_AUTH0_CLIENT_ID;
      var domain = process.env.REACT_APP_AUTH0_DOMAIN;

      // This is to ensure we share the same user session state as our other auth0 integration which doesn't use Lock.
      var PKCEState: any = await getPKCEState();
      var options = {
        allowLogin: false,
        theme: {
          logo: "https://assets.jazzgroove.org/updated-logo.svg",
          primaryColor: "#8490FF",
        },
        languageDictionary: {
          signUpTitle: "Sign Up To Listen",
          signUpSubmitLabel: "Sign Up To Listen",
          signUpTerms: "No credit card required. Free one-month membership.",
        },
        auth: {
          autoParseHash: false,
          responseType: "code",
          redirectUrl: window.location.origin + "/thank-you-ft",
          audience: process.env.REACT_APP_AUTH0_AUDIENCE,
          params: {
            state: PKCEState.state,
            code_challenge: PKCEState.code_challenge,
            code_challenge_method: PKCEState.code_challenge_method,
            nonce: PKCEState.nonce,
          },
        },
        additionalSignUpFields: [
          {
            name: "given_name",
            placeholder: "First Name",
            storage: "root",
          },
          {
            name: "family_name",
            placeholder: "Last Name",
            storage: "root",
          },
        ],
      };
      setLock(new Auth0Lock(clientId, domain, options));
    }
    initializeAuth0();

    setPageVersion(pageVersion);
    setCoupon(couponParam);

    if (queryContentfulEntry) setContentfulEntry(queryContentfulEntry);
    else setContentfulEntry("1XeMTSgmKvjNn9XtrFLLfv"); // default entry ID for both dev and prod
  }, []);

  if (isMobile && pageVersion === "a") {
    return (
      <>
        <BenefitsPopup
          open={true}
          showLock={goToTrialCheckout}
          onClose={() => {
            // console.log("popup closed");
          }}
          showClose={false}
          version="a"
        />
      </>
    );
  } else if (isMobile && pageVersion === "b") {
    return (
      <>
        <Player forceMobileView />
        <BenefitsPopup
          open={showBenefitsPopup}
          showLock={goToTrialCheckout}
          onClose={() => {
            // console.log("popup closed");
            setShowBenefitsPopup(false);
          }}
          showClose={showPopupCloseOption}
          version="b"
        />
      </>
    );
  }

  return (
    <>
      <Title value="Free Trial" />
      <Box
        sx={{
          position: "fixed",
          width: "100%",
          height: "104px",
          left: 0,
          top: 0,
          background:
            "linear-gradient(180deg, #121212 0%, rgba(0, 0, 0, 0) 100%)",
          pt: 2,
          pl: isMobile ? 1 : 10,
          pr: isMobile ? 1 : 10,
          zIndex: 15,
        }}
      >
        <Grid container xs={12}>
          <Grid xs={6} justifyContent={"flex-start"} sx={{ textAlign: "left" }}>
            <Box
              sx={{
                maxWidth: "169px",
                maxHeight: "75px",
                mx: 0,
              }}
            >
              <Logo height={"53px"} />
            </Box>
          </Grid>
          <Grid
            xs={6}
            alignItems={"right"}
            sx={{
              textAlign: "right",
              pr: isMobile ? 2 : 0,
              ml: isMobile ? -2 : 0,
              isolation: "isolate",
            }}
          >
            <Button
              color="darkPurple"
              type="button"
              className="tryitfree"
              onClick={goToTrialCheckout}
              sx={{
                padding: isMobile ? "15px 5px" : "15px 30px",
                minWidth: isMobile ? "200px" : "64px",
                "&:hover": {
                  backgroundColor: "primary.dark",
                },
              }}
            >
              Try It Free
            </Button>
          </Grid>
        </Grid>
      </Box>
      <Elements stripe={stripe}>
        <Box
          sx={{
            backgroundColor: "#121212",
            minHeight: "100%",
            width: "100%",
          }}
        >
          <Box
            sx={{
              height: "1119px",
              width: "100%",
              background: `url('${GrainBg}')`,
              backgroundPosition: "top right",
              backgroundSize: "contain",
              backgroundRepeat: "no-repeat",
              mixBlendMode: "overlay",
              zIndex: 2,
            }}
          ></Box>
          <Box
            sx={{
              height: "1800px",
              marginTop: "-1119px",
              background: `url('${Ellipse}')`,
              backgroundPosition: "top right",
              backgroundSize: "contain",
              backgroundRepeat: "no-repeat",
              backgroundColor: "#121212",
              zIndex: 1,
            }}
          ></Box>

          <Box
            sx={{
              height: isMobile ? "300px" : "800px",
              marginTop: "-1800px",
              background: `url('${ImagesCover}')`,
              backgroundPosition: isMobile
                ? "top -50px right -100px"
                : "top -150px right -200px",
              backgroundSize: isMobile ? "cover" : "contain",
              backgroundRepeat: "no-repeat",
              zIndex: 3,
              isolation: "isolate",
            }}
          ></Box>
          <Container
            sx={{
              height: "100%",
              marginTop: isMobile ? "-200px" : "-600px",
              zIndex: 5,
              position: "relative",
              isolation: "isolate",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                paddingTop: "50px",
              }}
            >
              <Typography
                variant="subtitle2"
                component="div"
                fontWeight="regular"
                sx={(theme) => ({
                  pt: 2,
                  fontFamily: theme.typography.fontFamily,
                  color: theme.palette.text.disabled,
                })}
              >
                Internet Radio. Non-profit.
              </Typography>
            </Box>
            <Box sx={{ display: "flex", alignItems: "center", mt: 2 }}>
              <Typography variant={"h1"} component="h1" fontWeight="bold">
                Laid-Back Jazz
              </Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                maxWidth: "500px",
                mt: 2,
              }}
            >
              <Typography variant={isMobile ? "subtitle2" : "body1"}>
                Feel your shoulders relax with The Jazz Groove's gentle swing of
                music, featuring artists like Miles Davis, Duke Ellington,
                Wynton Marsalis, and thousands more!
              </Typography>
            </Box>
            <Box sx={{ display: "flex", alignItems: "center", mt: 2 }}>
              <Typography
                variant={isMobile ? "h2" : "h1"}
                component="h1"
                fontWeight="bold"
              >
                <Button
                  color="darkPurple"
                  type="button"
                  className="tryitfree"
                  onClick={goToTrialCheckout}
                  sx={{
                    padding: "15px 30px",
                    "&:hover": {
                      backgroundColor: "primary.dark",
                    },
                  }}
                >
                  Try It Free
                </Button>
              </Typography>
            </Box>
          </Container>
        </Box>

        <Grid
          container
          height={isMobile ? "615px" : "615px"}
          sx={{
            maxWidth: "lg",
            margin: "0 auto",
            zIndex: 5,
            isolation: "isolate",
            mt: isMobile ? 10 : 20,
            overflow: "visible",
            background: `#5B64B2`,
            borderRadius: "18px",
          }}
        >
          <Grid
            item
            sm={12}
            md={6}
            sx={{
              py: isMobile ? 1 : 5,
              px: isMobile ? 3 : 12,
              textAlign: "left",
            }}
          >
            <Typography
              sx={{
                fontFamily: "futura-pt",
                fontWeight: 400,
                fontSize: isSmallMobile
                  ? "2.5em"
                  : isSmallDesktop
                  ? "3em"
                  : "3.5em",
                margin: "0 auto",
              }}
            >
              Member Benefits
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Grid
              container
              spacing={0}
              sx={{
                maxWidth: "1000px",
                margin: isMobile ? "0 10px" : "0 auto",
              }}
            >
              <Grid item xs={12} md sx={{ px: 1, pb: isMobile ? 2 : 0 }}>
                <Perk
                  icon={PremiumSilenceIcon}
                  title="Just the music"
                  body={
                    <>
                      No interruptions from promotional messages or fund drives.
                    </>
                  }
                />
              </Grid>
              <Grid item xs={12} md sx={{ px: 1, py: isMobile ? 2 : 0 }}>
                <Perk
                  icon={PremiumQualityIcon}
                  title="Hi-Res Audio"
                  body="Audiophile fidelity (Lossless FLAC)."
                />
              </Grid>
              <Grid item xs={12} md sx={{ px: 1, pt: isMobile ? 2 : 0 }}>
                <Perk
                  icon={PremiumSkipIcon}
                  title="Song Skips"
                  body={<>Want to listen to a different song? Click skip!</>}
                />
              </Grid>
              <Grid
                item
                xs={12}
                md
                sx={{ px: 1, pt: isMobile ? 2 : 0, mt: isMobile ? 2 : 0 }}
              >
                <Perk
                  icon={UnlimitedAccessIcon}
                  title="Unlimited Access"
                  body={
                    <>
                      Your listening won’t be be capped as it is for
                      non-members.
                    </>
                  }
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid
            container
            sx={{
              pt: 2,
              maxWidth: "400px",
              margin: "0 auto",
              mb: 4,
              textAlign: "center",
            }}
          >
            <Typography
              sx={{
                fontFamily: "futura-pt",
                fontWeight: 400,
                fontSize: isMobile ? "1em" : "1.5em",
                whiteSpace: "pre-line",
                margin: "0 auto",
              }}
            >
              <Link
                to={""}
                onClick={(e) => {
                  e.preventDefault();
                  lock.show();
                }}
                className="tryitfree"
                style={{ color: "white" }}
              >
                Try it free to unlock all these benefits!
              </Link>
            </Typography>
          </Grid>
        </Grid>
        <Grid
          container
          sx={{
            maxWidth: "lg",
            margin: "0 auto",
            pt: 15,
            overflow: "visible",
          }}
        >
          <Grid
            item
            sm={12}
            height={"615px"}
            sx={{
              background: `url('${CardsBg}')`,
              borderRadius: "18px",
              backgroundSize: "cover",
              backgroundRepeat: "no-repeat",
              textAlign: "center",
              overflow: "visible",
            }}
          >
            <Container
              sx={{
                spacing: 0,
                paddingTop: "50px",
                zIndex: 5,
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Box>
                <Typography
                  variant="subtitle2"
                  component="div"
                  fontWeight="regular"
                  sx={(theme) => ({
                    fontFamily: theme.typography.fontFamily,
                    color: theme.palette.text.disabled,
                    fontWeight: 500,
                  })}
                >
                  15,000+ songs across 5 unique jazz radio stations
                </Typography>
              </Box>
              <Box sx={{ mt: 2 }}>
                <Typography
                  sx={{
                    fontFamily: "futura-pt",
                    fontWeight: 450,
                    fontSize: "3.5em",
                  }}
                >
                  Jazz Legends & Rising Stars
                </Typography>
              </Box>
              <Box
                sx={{
                  pt: 2,
                  maxWidth: "700px",
                  margin: "auto",
                  mb: 10,
                }}
              >
                <Typography variant={isMobile ? "body1" : "body1"}>
                  Each hour of music is meticulously-curated and
                  artfully-blended from a rare collection of 15,000+ jazz
                  recordings spanning 8-decades
                </Typography>
              </Box>
            </Container>
          </Grid>
        </Grid>
        <Box sx={{ mt: isMobile ? "-220px" : "-330px" }}>
          <Carousel
            responsive={responsive}
            centerMode
            autoPlay={true}
            autoPlaySpeed={0}
            pauseOnHover={false}
            transitionDuration={2000}
            customTransition="transform 2s ease-in-out"
            infinite
            partialVisible={false}
            itemClass={styles.carouselPadding}
            arrows={false}
          >
            {legendsItems}
          </Carousel>
        </Box>
        <Box
          sx={{
            height: "4000px",
            marginTop: "-300px",
            background: `url('${EllipseBottom}')`,
            backgroundPosition: "bottom left",
            backgroundSize: "contain",
            backgroundRepeat: "no-repeat",
            backgroundColor: "#121212",
            zIndex: 1,
          }}
        ></Box>
        <Box
          sx={{
            height: "819px",
            marginTop: "-819px",
            width: "100%",
            background: `url('${GrainBg}')`,
            backgroundPosition: "bottom left",
            backgroundSize: "contain",
            backgroundRepeat: "no-repeat",
            mixBlendMode: "overlay",
            zIndex: 2,
            pointerEvents: "none",
          }}
        ></Box>
        <Box
          sx={{
            margin: "-3800px auto 0",
            maxWidth: "lg",
          }}
        ></Box>
        <Grid
          container
          height={
            isSmallMobile
              ? "1375px"
              : isMobile
              ? "1275px"
              : isSmallDesktop
              ? "1075px"
              : "940px"
          }
          sx={{
            maxWidth: "lg",
            margin: isMobile ? "220px auto 0" : "220px auto 0",
            overflow: "visible",
            zIndex: 5,
            isolation: "isolate",
            background: `#3C3C3C`,
            borderRadius: "18px",
          }}
        >
          <Grid
            item
            sm={12}
            sx={{
              textAlign: "center",
              overflow: "visible",
            }}
          >
            <Container
              sx={{
                spacing: 0,
                paddingTop: "50px",
                zIndex: 5,
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Box sx={{ mt: 1, mx: isMobile ? "20px" : "240px" }}>
                <Typography
                  sx={{
                    fontFamily: "futura-pt",
                    fontWeight: 450,
                    fontSize: isMobile ? "2em" : "3.5em",
                  }}
                >
                  Listen To The Jazz Groove On All Your Devices
                </Typography>
              </Box>
              <Grid
                container
                sx={{
                  pt: 2,
                  maxWidth: "1000px",
                  margin: "auto",
                  mb: 4,
                }}
              >
                <Device
                  icon={IoMdPhonePortrait}
                  title={"Smartphones"}
                  body={"iPhone & Android"}
                />
                <Device
                  icon={HiMiniComputerDesktop}
                  title={"Desktops"}
                  body={"PC & Mac"}
                />
                <Device
                  icon={FaTabletAlt}
                  title={"Tablets"}
                  body={"iOS & Android"}
                />
                <Device
                  icon={BsFillSpeakerFill}
                  title={"Speakers"}
                  body={"TV & Audio"}
                />
                <Device icon={SiSonos} title={""} body={""} size={120} />
                <Device icon={SiAmazonalexa} title={"Amazon Alexa"} body={""} />
                <Device icon={SiTunein} title={"TuneIn"} body={""} />
                <Device image={Heos} title={""} height="50px" body={""} />
                <Device icon={SiAndroidauto} title={"Android Auto"} body={""} />
                <Device icon={FaApple} title={"Apple CarPlay"} body={""} />
                <Device icon={FaChromecast} title={"Google Cast"} body={""} />
                <Device icon={FiAirplay} title={"Apple AirPlay"} body={""} />
              </Grid>
              <Grid
                container
                sx={{
                  pt: 2,
                  maxWidth: "400px",
                  margin: "0 auto",
                  mb: 4,
                  textAlign: "center",
                }}
              >
                <Typography
                  sx={{
                    fontFamily: "futura-pt",
                    fontWeight: 400,
                    fontSize: isMobile ? "1em" : "1.5em",
                    whiteSpace: "pre-line",
                    margin: "0 auto",
                  }}
                >
                  Plus Many Other Audio Devices & Apps{"\n"}
                  <Link
                    to={""}
                    onClick={(e) => {
                      e.preventDefault();
                      lock.show();
                    }}
                    className="tryitfree"
                  >
                    Try it free to unlock device setup!
                  </Link>
                </Typography>
              </Grid>
            </Container>
          </Grid>
        </Grid>
        <Grid
          container
          sx={{
            maxWidth: "lg",
            margin: "0 auto",
            pt: 15,
            mb: 7,
            overflow: "visible",
          }}
        >
          <Grid
            item
            sm={12}
            sx={{
              textAlign: "center",
              overflow: "visible",
            }}
          >
            <Container
              sx={{
                spacing: 0,
                zIndex: 5,
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Box sx={{ mt: 2 }}>
                <Typography
                  sx={{
                    fontFamily: "futura-pt",
                    fontWeight: 450,
                    fontSize: "3.5em",
                    lineHeight: "1.3em",
                  }}
                >
                  Jazz Groove listeners share why they donated
                </Typography>
              </Box>
            </Container>
          </Grid>
        </Grid>
        <Box
          sx={{
            position: "relative",
            width: "140%",
            marginLeft: "-20%",
            zIndex: 7,
          }}
        >
          <div className="slider-arrow">
            <Avatar
              className="arrow-btn-prev"
              onClick={() => sliderRef.current?.slickPrev()}
            >
              <NavigateBeforeIcon sx={{ color: "white" }} />
            </Avatar>
            <Avatar
              className="arrow-btn-next"
              onClick={() => sliderRef.current?.slickNext()}
            >
              <NavigateNextIcon sx={{ color: "white" }} />
            </Avatar>
          </div>

          <Slider
            ref={sliderRef}
            infinite
            adaptiveHeight={false}
            variableWidth={false}
            arrows={false}
            centerMode
            centerPadding={"0px"}
            slidesToShow={isMobile ? 1 : 3}
            slidesToScroll={1}
          >
            {testimonialsItems}
          </Slider>
        </Box>
        {/* <Grid
          container
          sx={{
            maxWidth: "lg",
            margin: "0 auto",
            pt: 20,
            mb: 0,
            overflow: "visible",
          }}
        >
          <Grid
            item
            sm={12}
            sx={{
              textAlign: "center",
              overflow: "visible",
            }}
          >
            <Container
              sx={{
                spacing: 0,
                zIndex: 5,
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Box
                id="form"
                sx={{
                  mt: 2,
                  display: !loading ? "block" : "none",
                }}
              >
                <Typography
                  sx={{
                    fontFamily: "futura-pt",
                    fontWeight: 450,
                    fontSize: "3em",
                    lineHeight: "1.3em",
                  }}
                >
                  {(emailFocused && (
                    <>
                      Enter your email address below to try all the member
                      benefits for free!
                    </>
                  )) || (
                    <>
                      Enter your email address below to try all the member
                      benefits for free!
                    </>
                  )}
                </Typography>
              </Box>
            </Container>
          </Grid>
        </Grid> */}

        <Box
          sx={{
            pt: 5,
            pb: 8,
            margin: "0 auto 0",
            maxWidth: isMobile ? "lg" : "66%",
            zIndex: 5,
          }}
        >
          {freeTrialDoc?.active && coupon && (
            <>
              {/* <div
                ref={checkoutRef}
                style={{
                  display: checkoutEnabled && !loading ? "block" : "none",
                  pointerEvents: "auto",
                }}
              >
                <CheckoutStepper
                  isMobile={isMobile}
                  setShowLanding={(val) => {
                    if (isMobile) setShowLanding(val);
                  }}
                  freeTrial={true}
                  email={email}
                  freeTrialFormCompleted={freeTrialFormCompleted}
                ></CheckoutStepper>
              </div> */}

              {/* <div
                style={{
                  display: checkoutEnabled ? "none" : "block",
                  margin: isMobile ? 10 : "auto",
                }}
              > */}
              {/* <FormControl
                  fullWidth
                  sx={{ mt: 1 }}
                  onSubmit={() => validateEmailAndSend()}
                > */}
              {/* <InputLabel htmlFor="email">Enter Email address</InputLabel>
                  <OutlinedInput
                    id="email"
                    type="email"
                    inputRef={emailRef}
                    value={email}
                    onChange={(e) => {
                      setEmail(e.target.value);
                    }}
                    onBlur={(e) => {
                      setEmail(e.target.value);
                    }}
                    onFocus={(e) => {
                      // console.log("focused");
                      setEmail(e.target.value);
                    }}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        validateEmailAndSend();
                      }
                    }}
                    required
                    label="Email"
                  />
                  {emailError && (
                    <Alert severity="error" sx={{ mt: 1 }}>
                      {emailError}
                    </Alert>
                  )} */}

              {/* <Button
                    color="darkPurple"
                    type="submit"
                    className="getstarted"
                    onClick={() => lock.show()}
                    sx={{
                      padding: isMobile ? "15px 5px" : "15px 30px",
                      minWidth: isMobile ? "200px" : "64px",
                      mt: "20px",
                      "&:hover": {
                        backgroundColor: "primary.dark",
                      },
                    }}
                  >
                    Get Started!
                  </Button> */}
              {/* </FormControl> */}
              {/* </div> */}
            </>
          )}
        </Box>

        {/* <Grid
          container
          sx={{
            maxWidth: "lg",
            margin: "0 auto",
            pt: 5,
            mb: 20,
            overflow: "visible",
          }}
        >
          <Grid
            item
            sm={12}
            sx={{
              textAlign: "center",
              overflow: "visible",
              zIndex: 7,
            }}
          >
            <Container
              sx={{
                spacing: 0,
                zIndex: 5,
                alignItems: "center",
                justifyContent: "center",
                display: "flex-end",
              }}
            >
              <Box sx={{ mt: 2, mb: 4 }}>
                <Typography
                  sx={{
                    fontFamily: "futura-pt",
                    fontWeight: 450,
                    fontSize: "3.5em",
                    lineHeight: "1.3em",
                  }}
                >
                  Frequently Asked Questions
                </Typography>
              </Box>

              <Box sx={{ mt: 2 }}>
                <Button
                  color="darkPurple"
                  component={Link}
                  to={"/devices"}
                  sx={{
                    padding: "20px 50px",
                    margin: isSmallMobile ? "10px auto" : "0 0 0 30px",
                    fontSize: "1.5em",
                    "&:hover": {
                      backgroundColor: "primary.dark",
                    },
                  }}
                >
                  Devices FAQ
                </Button>

                <Button
                  color="darkPurple"
                  component={Link}
                  to={"/help"}
                  sx={{
                    padding: "20px 50px",
                    margin: isSmallMobile ? "10px auto" : "0 0 0 30px",
                    fontSize: "1.5em",
                    "&:hover": {
                      backgroundColor: "primary.dark",
                    },
                  }}
                >
                  General FAQ
                </Button>
              </Box>
            </Container>
          </Grid>
        </Grid> */}
      </Elements>
      {/* need to keep this div here for scrolling */}
      <div style={{ height: "50px" }}></div>
      <div ref={formRef}></div>
      <Box sx={{ zIndex: 10, position: "relative" }}>
        <Footer />
      </Box>
      <Player />
    </>
  );
};

export default FreeTrial;
